import QuizGradingLayout from 'components/QuizGrading/QuizGradingLayout';

const Mobile = (props) => <QuizGradingLayout device={'mobile'} {...props} />;
export default Mobile;
